<div class="home" data-testid="ogef-home-container">
  <div class="body">
    <div class="header my-5">
      <img src="/assets/images/ogef/ogef.jpg" width="340px">
    </div>
    <div class="image-display">
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/ogef6.jpg"/>
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/ogef4.jpg"/>
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/ogef8.jpg"/>
    </div>
    <h4>{{ 'themes.partners' | translate }}:</h4>
    <div class="bg-container">
      <div class="logos mb-5">
        <img src="/assets/images/ogef/fdi.png" width="200px" class="mr-2">
        <img src="/assets/images/ogef/bcp.png" width="200px" class="ml-2">
      </div>
    </div>
    <div class="help-banner">
      <h4>{{ 'home.questions-1' | translate }}</h4>
      <p>{{ 'home.questions-2' | translate }}</p>
    </div>
  </div>
</div>

